import { ButtonV2, TextInputV2 } from '@labrav/react-components'
import { Form, Formik } from 'formik'
import { useStyles } from './AddEditCompetitors.styles'
import { useCallback, useState } from 'react'
import { ListingUrlInputValidationSchema } from './ListingUrlInputValidationSchema'
import { fetchAndSaveCompetitor } from '../../../modules/mpsSeo/action'
import { useDispatch, useSelector } from '../../../store'
import { CompetitorType } from '../../../modules/mpsSeo/reducer'
import { LoadingTypes, isLoading as Loading } from '@labrav/common'
import { SEO_CLOUD_MARKETPLACE, useSeoAccountId } from '../seoCloud'

export const ListingUrlInput = () => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const accountId = useSeoAccountId()
  const selectedCloud = SEO_CLOUD_MARKETPLACE
  const [listingUrlErr, setListingUrlErr] = useState('')
  const competitors = useSelector<CompetitorType[]>(
    state => state.marketplaceSeo[selectedCloud].competitors
  )
  const selfListingUrl = useSelector<string | undefined>(
    state => state.marketplaceSeo[selectedCloud].listingUrl
  )
  const isLoading = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.SAVE_COMPETITOR)
  )

  return (
    <Formik
      initialValues={{
        listingUrl: '',
      }}
      validationSchema={ListingUrlInputValidationSchema}
      validateOnMount={true}
      onSubmit={() => {}}
      enableReinitialize
    >
      {formikProps => {
        const { values, errors, touched, handleBlur } = formikProps

        const handleSubmit = async () => {
          await formikProps.submitForm()
          const isErr = !!errors?.listingUrl
          if (!isErr) {
            const listingUrl = values?.listingUrl?.split('?')[0]
            handleFetchOrSaveCompetitor(
              listingUrl.substring(listingUrl.lastIndexOf('/') + 1)
            )
          }
        }

        const callBackCompetitor = async ({
          success,
          error,
        }: {
          success?: true
          error?: string
        }) => {
          if (success) {
            await formikProps.setFieldValue('listingUrl', '')
            await formikProps.setFieldTouched('listingUrl', false)
          }
          if (error) {
            setListingUrlErr(error)
          }
        }

        const handleFetchOrSaveCompetitor = useCallback(
          (productId: string) => {
            setListingUrlErr('')
            if (accountId) {
              dispatch(
                fetchAndSaveCompetitor({
                  partnerId: accountId,
                  productId,
                  cloudMarketplace: selectedCloud,
                  callBackCompetitor,
                })
              )
              if (!competitors?.length) {
                const selfProductID =
                  selfListingUrl?.substring(
                    selfListingUrl?.lastIndexOf('/') + 1
                  ) || ''
                dispatch(
                  fetchAndSaveCompetitor({
                    partnerId: accountId,
                    productId: selfProductID,
                    self: true,
                    cloudMarketplace: selectedCloud,
                  })
                )
              }
            }
          },
          [competitors]
        )

        return (
          <Form>
            <div
              className={classes.inputWrapper}
              data-testid={'listing-url-section'}
            >
              <div className={classes.input}>
                <TextInputV2
                  keyName="listingUrl"
                  title={
                    "Copy paste one of your competitor's Listing URLs from AWS Marketplace"
                  }
                  supportingText="Eg. https://aws.amazon.com/marketplace/pp/prodview-zhtwhroiq2luq"
                  type="text"
                  placeHolder=""
                  size={'medium'}
                  value={values?.listingUrl || ''}
                  updatedValue={values?.listingUrl || ''}
                  onBlur={handleBlur}
                  onChange={e =>
                    formikProps.setFieldValue('listingUrl', e?.target?.value)
                  }
                  isError={
                    !!(errors?.listingUrl && touched?.listingUrl) ||
                    !!listingUrlErr
                  }
                  errorText={
                    (!!touched?.listingUrl && errors?.listingUrl) ||
                    listingUrlErr ||
                    ''
                  }
                  isReadOnly={false}
                  isRequired={false}
                  showSpinner={false}
                />
              </div>
              <div className={classes.buttonWrapper}>
                <ButtonV2
                  data-testid={'fetch-and-save'}
                  className={classes.fetchAndSave}
                  onClick={handleSubmit}
                  loading={isLoading}
                >
                  Save
                </ButtonV2>
              </div>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}
